export default {
  // GeneralReport
  reportsTitle: 'Reportes',
  reportsSubtitle: 'Sistema de seguimiento de resultados de aprendizaje',
  selectReportType: 'Seleccione el tipo de Reporte',
  selectReportTypePlaceholder: '-- Selecciona un tipo de reporte --',
  configureFilters: 'Configure los filtros específicos para el reporte seleccionado',
  generateReport: 'Generar Reporte',
  clearFilters: 'Limpiar Filtros',
  welcomeMessage: 'Bienvenido {firstName} {lastName}',
  welcomeDescription: 'En el Sistema de Reportes podrás acceder a diferentes tipos de reportes sobre el seguimiento de resultados de aprendizaje. Entre todos los reportes disponibles, algunos ejemplos son:',
  generatingReport: 'Generando Reporte...',
  pleaseWait: 'Por favor, espera mientras se genera el reporte.',
  noEgressProfileCompetencesTooltip: 'El {egressProfile} seleccionado no tiene {competences} asociadas, por lo que este reporte no puede generarse.',

  // Report Types
  assessmentByMatter: 'Reporte de Assessment por {matter} del {egressProfile}',
  assessmentByCompetence: 'Reporte de Assessment por {competences} del {egressProfile}',
  assessmentGroupCompetence: 'Reporte de Assessment grupal de logros de {competences} del {egressProfile}',
  assessmentGroupRaMicro: 'Reporte de Assessment grupal de logros de {raMicro} por {matter}',
  assessmentGroupCriteria: 'Reporte de Assessment grupal de logros de {evaluationCriteria} por {matter}',
  averageGradesReport: 'Promedios de Notas del {egressProfile} por Niveles y Rangos',
  progressionReport: 'Reporte de Progresión de las {evaluations}',
  reportIndividualGrades: 'Reporte de notas individuales por {matter}',

  // Filters
  admissionYear: 'Año de Ingreso',
  cohortIndex: 'Índice de Cohorte',
  level: 'Nivel',
  modality: 'Modalidad',
  progression: 'Progresión',
  periodType: 'Tipo de {period}',
  teachers: 'Docentes',
  currentPeriods: '{periods} Actuales',
  pastPeriods: '{periods} Pasados',
  inRegime: 'En Régimen',
  notInRegime: 'No en Régimen',
  regime: 'Régimen',
  declaredCohort: 'Cohorte declarada',
  expectedLevel: 'Nivel esperado',
  stagePrevious: 'previo',
  stageCurrent: 'actual',
  stageFuture: 'futuro',
  gradeApproved: 'aprobada',
  gradeFailed: 'reprobada',
  gradeInProgress: 'en curso',

  // AchievementExplanationBadge
  achievementCalculation: 'Cálculo del logro',
  summativeAchievement: 'Logro sumativo',
  formativeAchievement: 'Logro formativo',
  sectionSelected: 'considerada',
  sectionDiscarded: 'no considerada',
  contributes: 'aporta',
  notConsideredNoAchievement: 'sin logro, no se considera',
  notConsideredNoWeight: 'peso 0, no se considera',
  itemQuestion: 'Pregunta',
  points: 'pts',

  // TagSelector
  requiredFieldTooltip: 'Debe seleccionar al menos un elemento.',
  clearSelectedTooltip: 'Limpiar elementos seleccionados.',
  noOptionsAvailable: 'Nada para seleccionar.',
  year: 'Año',

  // AssessmentRangeSection
  assessmentReportBy: 'REPORTE DE ASSESSMENT POR {entity}',

  // AchievementRangeGroupSelector
  selectAchievementRange: 'Seleccionar rango de logro:',

  // AssessmentRangeTable
  formative: 'FORMATIVAS',
  summative: 'SUMATIVAS',
  visualizeColumns: 'Visualizar columnas',
  reportXlsx: 'Reporte XLSX',
  reportCompetenceXlsx: 'Reporte de {competences}',
  number: 'N°',
  lastName: 'Apellido',
  firstName: 'Nombre',
  identifier: 'IDENTIFICADOR',
  admissionYearUpper: 'AÑO DE INGRESO',
  grade: 'NOTA',
  finalGradeTooltip: 'Nota Final de la {matter}',
  name: 'Nombre',
  range: 'RANGO',
  achievementRanges: 'RANGOS DE LOGROS',
  assessmentReportByMatterEgressProfile: 'REPORTE DE ASSESSMENT POR ASIGNATURA DE PERFIL DE EGRESO',
  numberOfStudents: 'N° de Estudiantes',
  assessment: 'Assessment',

  // TeacherInfoTable
  teachersUpper: 'DOCENTE(S)',

  // AssessmentRangeSelector
  expectedLearning: 'Aprendizaje Esperado:',

  // AssessmentCompetenceEgrProTable
  assessmentReportByCompetenceEgressProfile: 'Reporte de assessment por {competences} del perfil de egreso',
  inRegimeStudentsOnly: 'Este cuadro aplica solo para estudiantes',
  completed: 'Cursada',
  inProgress: 'En Proceso',
  pending: 'Por Cursar',
  legendOf: 'Leyenda de',
  ofThePlan: 'del plan',

  // AssessmentGroupCompEgrProTable
  tributationOf: 'Tributación de',
  noRecord: 'Sin registro',
  totalStudents: 'Total estudiantes',
  quantity: 'Cantidad',
  percentageSymbol: '%',
  averageAchievementOfMatter: 'Promedio de logro de la {matter}',
  total: 'Total',
  assessmentGroupCompetenceReportTitle: 'Reporte de assessment grupal de logros de {competences} del {egressProfile}',

  // AssessmentGroupStudyUnitTable
  assessmentGroupRaMicroReportTitle: 'Reporte de assessment grupal de logros de {raMicro} del {egressProfile}',
  assessmentGroupRaMicroByMatterReportTitle: 'Reporte de assessment grupal de logros de {raMicro} por {matter}',
  selectSection: 'Seleccione una Sección',
  viewAll: 'Ver todos los {assessmentType}',
  quantityPercentage: 'Cantidad/Porcentaje',
  cant: 'Cant',
  percentage: 'Porcentaje',
  noDataToDisplay: 'No hay datos que mostrar',

  // AssessmentGroupEvaluationCriteriaTable
  assessmentGroupEvaluationCriteriaReportTitle: 'Reporte de assessment grupal de logros de {evaluationCriteria} por {matter}',
  raCe: 'RA - CE',
  statement: 'Enunciado',
  noRange: 'Sin rango',
  selectPeriod: 'Seleccione un Período',
  viewAllAssessments: 'Ver todos los Assessment',
  competenceUnitNumber: 'UC N°',
  evaluationInProgress: 'Evaluación en Proceso...',

  // GradeRangeGroupSelector
  selectGradeRange: 'Seleccionar rango de notas',

  // EvaluationGradeReportTable
  averagesByMatterTitle: 'Promedios por {matter} del {egressProfile} por rangos y niveles',
  gradeRanges: 'Rangos de notas',
  rangePercentage: 'Rango (%)',
  averageGradesByEgressProfileTitle: 'Promedios de notas del {egressProfile} por niveles y rangos',
  viewAllLevels: 'Ver todos los Niveles',

  // ProfessorProgressionReportTable
  progressionReportTitle: 'Reporte de progresión de las {evaluations}',
  evaluationType: 'Tipo de {evaluation}',
  professors: 'Profesores',
  studentsStarted: 'Estudiantes que iniciaron',
  studentsStartedNotFinished: 'Estudiantes que iniciaron pero no terminaron',
  studentsFinished: 'Estudiantes que terminaron',
  studentsGradePublished: 'Estudiantes con nota publicada',
  navigation: 'Navegación',
  sectionGrades: 'Notas de la {section}',
  sectionEvaluations: '{evaluations} de la {section}',
  noSectionsFoundWithFilters: 'No se encontraron secciones con los filtros aplicados.',

  // TagSelectorWithPagination
  searchPlaceholder: 'Buscar {title}...',
  loading: 'Cargando {title}...',
  noResultsFound: 'No se encontraron {title} con "{search}"',
  typeToFilter: 'Escriba para filtrar {title}...',
  previous: 'Anterior',
  next: 'Siguiente',
  loadingError: 'Error al cargar usuarios',

  // IndividualMatterGradesReportTable
  individualGradesBy: 'notas individuales por',
  of: 'del',
  gradeHistoryIn: 'historial de notas en',
  current: 'actual',
  cohort: 'cohorte',
  byLevelsAndRanges: 'por niveles y rangos',
  problemGeneratingReport: 'Hubo un problema generanto el reporte.',
}
